import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown.js";
import ArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft.js";
import ArrowRightIcon from "@mui/icons-material/KeyboardArrowRight.js";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp.js";
import { Button, Popover } from "@mui/material";
import { DATE_FORMATS } from "../../../constants/date/date.js";
import { format, sub, add } from "date-fns";
import { DatePicker } from "../date-picker/date-picker.js";
import { Wrapper, StyledIconButton } from "./day-picker.styles.js";
import "@mui/x-date-pickers";
import "@mui/x-date-pickers/AdapterDateFns/index.js";
import "@mui/x-date-pickers/DatePicker/index.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "../../../type/Translations.js";
import "date-fns/locale";
import "../pickers-action-bar/pickers-action-bar.js";
import "@mui/material/Button/index.js";
import "@mui/material/styles";
import "@mui/x-date-pickers/internals/index.js";
import "../../../constants/create-theme/create-theme.js";
import "../../../constants/colors/palette.js";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/typography.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../pickers-action-bar/pickers-action-bar.styles.js";
import "../../text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../text-field/text-field.styles.js";
import "../date-picker/theme/index.js";
import "../../../themes/date-calendar/date-calendar.js";
import "../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../themes/day-calendar/day-calendar.js";
import "../../../themes/filled-input/filled-input.js";
import "../../../themes/form-helper-text/form-helper-text.js";
import "../../../themes/form-label/form-label.js";
import "../../../themes/month-calendar/month-calendar.js";
import "../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../themes/pickers-day/pickers-day.js";
import "../../../themes/pickers-month/pickers-month.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import "../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../themes/pickers-year/pickers-year.js";
import "../../../themes/year-calendar/year-calendar.js";
const DayPicker = ({ value = /* @__PURE__ */ new Date(), onChange, currentLanguage = "de", labels }) => {
  const [buttonRef, setButtonRef] = useState(null);
  const handleButtonClick = (event) => setButtonRef(event.currentTarget);
  const handleBackButtonClick = () => {
    const previousDate = sub(value, { days: 1 });
    onChange(previousDate);
  };
  const handleNextButtonClick = () => {
    const nextDate = add(value, { days: 1 });
    onChange(nextDate);
  };
  const handleClosePicker = () => setButtonRef(null);
  const buttonValue = useMemo(() => format(value, DATE_FORMATS.DAY_MONTH_YEAR), [value]);
  return /* @__PURE__ */ jsxs(Wrapper, { children: [
    /* @__PURE__ */ jsx(StyledIconButton, { size: "md", color: "transparent", onClick: handleBackButtonClick, children: /* @__PURE__ */ jsx(ArrowLeftIcon, {}) }),
    /* @__PURE__ */ jsx(
      Button,
      {
        onClick: handleButtonClick,
        variant: "bordered",
        fullWidth: true,
        size: "sm",
        endIcon: buttonRef ? /* @__PURE__ */ jsx(KeyboardArrowUpIcon, {}) : /* @__PURE__ */ jsx(KeyboardArrowDownIcon, {}),
        children: buttonValue
      }
    ),
    /* @__PURE__ */ jsx(
      Popover,
      {
        open: !!buttonRef,
        anchorEl: buttonRef,
        onClose: handleClosePicker,
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        children: /* @__PURE__ */ jsx(
          DatePicker,
          {
            isStatic: true,
            open: true,
            value,
            language: currentLanguage,
            onClose: handleClosePicker,
            onAccept: onChange,
            views: ["year", "month", "day"],
            labels
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(StyledIconButton, { size: "md", color: "transparent", onClick: handleNextButtonClick, children: /* @__PURE__ */ jsx(ArrowRightIcon, {}) })
  ] });
};
export {
  DayPicker
};
